import type { RouteLocationNormalized } from 'vue-router';
import { menusPermissionScope, useMenuPermissionsStore } from '@centric-os/stores/auth/use-menu-permissions-store';
import { useAuthStore } from '@centric-os/stores/auth/use-auth-store';
import { SitesRouteNames } from '@centric-os/sites';
import { MenuScopeActions, MenuScopeServices, type RecordEntityId } from '@centric-os/types';

export const beforeEnterGuard = (to: RouteLocationNormalized) => {
  const authStore = useAuthStore();
  const menuPermissionsStore = useMenuPermissionsStore();

  if (!menuPermissionsStore.canAccessGlobalMenuGroupsSection) {
    return { name: SitesRouteNames.SITES_LIST };
  }

  const scopesIds: RecordEntityId[] = authStore.getScopeIds(
    MenuScopeActions.READ,
    MenuScopeServices.GLOBAL_MENU_GROUP,
  );
  const targetId = to?.params?.id as RecordEntityId;

  // targetId is present only if the user uses a url directly, otherwise it's undefined
  if (!targetId) return true;

  if (
    authStore.hasPermissions([menusPermissionScope.fullGlobalMenuGroupAdmin]) ||
    scopesIds?.includes(targetId)
  )
    return true;

  return { name: SitesRouteNames.SITES_LIST };
};
